import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import {
  COLOR_RED,
  COLOR_YELLOW,
  COLOR_GREEN,
  COLOR_PRIMARY,
  COLOR_PRIMARY_LIGHT,
} from 'src/utils/const';

const styles: any = {
  background: {
    position: 'absolute' as 'absolute',
    top: 0,
    right: 0,
    minWidth: 300,
    maxWidth: 900,
    width: '50vw',
    height: '100dvh',
    bgcolor: '#fff',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
    zIndex: 2000,
    overflowY: 'auto',
  },
  button: {
    background: COLOR_PRIMARY,
    borderRadius: 5,
    color: 'white',
    padding: '10px 15px',
    boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
    '&:hover': {
      background: COLOR_PRIMARY_LIGHT,
    },
    width: '100%',
  },
  confidenceScoreIconOuter: {
    width: 50,
    height: 50,
    borderRadius: 50,
    background: `linear-gradient(90deg, ${COLOR_RED} 0%, ${COLOR_YELLOW} 35%, ${COLOR_GREEN} 100%)`,
    position: 'absolute',
    top: 7,
    right: 7,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  confidenceScoreIconInner: {
    width: 44,
    height: 44,
    borderRadius: 44,
    background: '#123',
    cursor: 'pointer',
  },
  revealButton: {
    fontSize: '20px',
    fontWeight: 500,
    color: COLOR_PRIMARY_2,
    cursor: 'pointer',
    pointerEvents: 'auto',
    zIndex: 2,
    background: '#fff',
    borderRadius: '20px',
    padding: '10px 20px',
    boxShadow: '0 8px 24px -4px #0006, 0 2px 8px -2px #0002',
    textAlign: 'center',
  },
};

export default styles;
